import { render, staticRenderFns } from "./RuleNewPage.vue?vue&type=template&id=71973e58"
import script from "./RuleNewPage.vue?vue&type=script&lang=ts"
export * from "./RuleNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports